export default {
  basic: () => import("/home/runner/work/grove-web/grove-web/layouts/basic.vue").then(m => m.default || m),
  default: () => import("/home/runner/work/grove-web/grove-web/layouts/default.vue").then(m => m.default || m),
  embedded: () => import("/home/runner/work/grove-web/grove-web/layouts/embedded.vue").then(m => m.default || m)
}